import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { APP_CONFIG } from '@/config/app';
const { API: { RETRY_ATTEMPTS, RETRY_DELAY } } = APP_CONFIG;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
      retry: RETRY_ATTEMPTS,
      retryDelay: RETRY_DELAY,
      refetchOnReconnect: true,
      networkMode: 'online',
    },
    mutations: {
      retry: 0,
    },
  },
});

export function getQueryClient() {
  return {
    queryClient,
  };
}

export function Provider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
